"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authentication = void 0;
const __1 = require("../..");
const AzureADB2C_1 = require("./AzureADB2C/");
class Authentication {
    constructor(options) {
        this.authClient = new AzureADB2C_1.AuthModule(options !== null && options !== void 0 ? options : __1.ProductionStage);
    }
    loadAuthModule() {
        return this.authClient.loadAuthModule();
    }
    addEventCallback(callback) {
        return this.authClient.addEventCallback(callback);
    }
    removeEventCallback(callbackId) {
        return this.authClient.removeEventCallback(callbackId);
    }
    async signIn(options) {
        return await this.authClient.signIn(options);
    }
    async signInImpersonation() {
        return await this.authClient.signInImpersonation();
    }
    async signUp() {
        return await this.authClient.signUp();
    }
    async signOut(options) {
        return await this.authClient.signOut(options);
    }
    async changePassword() {
        return await this.authClient.changePassword();
    }
    async getToken() {
        return await this.authClient.getToken();
    }
    isNew() {
        var _a, _b;
        const account = this.authClient.getAccount();
        return (_b = (_a = account === null || account === void 0 ? void 0 : account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('isNew')) !== null && _b !== void 0 ? _b : false;
    }
    isSignedIn() {
        var _a;
        const account = this.authClient.getAccount();
        const idTokenClaims = account === null || account === void 0 ? void 0 : account.idTokenClaims;
        const userEmail = (idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.emails) && idTokenClaims.emails.length >= 0 ? idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.emails[0] : null;
        const impersonatedUser = (_a = idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.impersonatedUser) !== null && _a !== void 0 ? _a : null;
        return userEmail !== null || impersonatedUser !== null;
    }
    getAccount() {
        return this.authClient.getAccount();
    }
    getEmail() {
        var _a;
        const account = this.authClient.getAccount();
        const idTokenClaims = account === null || account === void 0 ? void 0 : account.idTokenClaims;
        return ((_a = ((idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.emails) && idTokenClaims.emails.length >= 0
            ? idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.emails[0]
            : idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.impersonatedUser)) !== null && _a !== void 0 ? _a : '');
    }
    onAccountChanged(cb) {
        return this.authClient.onAccountChanged(cb);
    }
    onUserSignedIn(cb) {
        this.authClient.onUserSignedIn(cb);
    }
    onUserSignedOut(cb) {
        this.authClient.onUserSignedOut(cb);
    }
    async editProfile() {
        return await this.authClient.editProfile();
    }
}
exports.Authentication = Authentication;
